import styled from 'styled-components';

import { SectionTitle as Title } from '../../../../components/layout';

export const SectionTitle = styled(Title)`
  .section__header {
    padding: 13px 0;
  }
`;
